import { useState } from 'react';
import { ButtonStatusVariant } from '../../../components/ButtonWithFeddback';
import useHandleAppException, { AppExceptionResponse } from '../../../hooks/useHandleAppException';
import api from '../../../services/api';
import snackbarStore from '../../../stores/Snackbar.store';
import { sleep } from '../../../utils/generics';

interface UseOAuthConsentReturn {
  handleConsent: () => Promise<void>;
  handleDeny: () => Promise<void>;
  consentStatus: ButtonStatusVariant;
}

const useOAuthConsent = (oauthRequestId: string): UseOAuthConsentReturn => {
  const [consentStatus, setConsentStatus] = useState<ButtonStatusVariant>('normal');
  const { handleErrorResponse } = useHandleAppException();

  const submitConsent = async (isGranted: boolean) => {
    setConsentStatus('loading');

    const response = await api.oauthConsent({
      oauth_request_id: oauthRequestId,
      granted: isGranted,
    });

    if (response.ok && response.data?.redirect_to) {
      window.location.href = response.data.redirect_to;
      return;
    }

    setConsentStatus('error');
    const message = handleErrorResponse(response as unknown as AppExceptionResponse);
    snackbarStore.handleMessage({ message, type: 'error' });

    await sleep(1500);
    setConsentStatus('normal');
  };

  const handleConsent = () => submitConsent(true);
  const handleDeny = () => submitConsent(false);

  return { handleConsent, handleDeny, consentStatus };
};

export default useOAuthConsent;
